import axios from 'axios';
import { useFormik } from 'formik';
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup'
import { paths } from '../../utils/routes';
import { Helmet } from 'react-helmet'

export default function ForgetPassword() {
    <Helmet>
        <meta charSet="utf-8" />
        <title>Forget Password</title>
    </Helmet>

    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState('');
    const navigator = useNavigate()
    const initialValues = {
        email: '',
    }

    const sendPasswordResetEmail = async (data) => {
        try {
            setIsLoading(true)
            const response = await axios.post("https://ecommerce.routemisr.com/api/v1/auth/forgotPasswords", { ...data })
            navigator(`${paths.verifyResetCode}`)
        } catch (error) {
            setError(error.toString())
        }
    }


    const validationSchema = Yup.object({
        email: Yup.string().email('Email is Invalid').required('Email is Required'),
    })
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: sendPasswordResetEmail
    })
    return <>
        <div className="w-75 m-auto p-3">
            <h3 className='my-3'>Reset Password</h3>
            {error && <p className='alert alert-danger'>{error}</p>}
            <form onSubmit={formik.handleSubmit}>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" className='form-control my-2' onChange={formik.handleChange} onBlur={formik.handleBlur} />
                {formik.errors.email && formik.touched.email && <p className='alert alert-danger'> {formik.errors.email}</p>}

                <button type='submit' className='bg-main btn text-white mt-2' disabled={!(formik.errors && formik.dirty)}>{isLoading ? <i className="fa-solid fa-spinner fa-spin"></i> : 'Reset'}</button>
            </form>
        </div>
    </>
}
